module.exports = __webpack_public_path__ + "img/awaits.81fae88f.png";